// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"kF5Q-","dataHookWrapper":"kF5Q-","core-badge":"_2upu-","coreBadge":"_2upu-"};